import React from "react";
import locale, { toLocale } from "@bonliva-crm/locale";
import { Body } from "@components";
import { TableSearchColumn } from "@search/TableSearch";
import { Row } from "./utils";
import { Delete, Restore } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import {
  CustomerContracts,
  CustomerContractStatus,
  DeleteRestoreCustomerContract
} from "@graphql";
import { store } from "@store";

const handleDeleteContract = (id: string, isRestore: boolean) => {
  store().ui.confirmNullify(isRestore ? locale.Restore : locale.Delete, (confirmed) => {
    if (!confirmed) {
      return;
    }
    DeleteRestoreCustomerContract.func(
      { contractId: id },
      { refetchQueries: [CustomerContracts.OperationName] }
    )
      .then(({ data }) => {
        if (data.deleteRestoreCustomerContract.errors) {
          store().snackbars.error(
            `Cannot delete form.\n Reason: ${data.deleteRestoreCustomerContract.errors}`
          );
        }
        store().snackbars.success(
          data.deleteRestoreCustomerContract.value.deleted
            ? locale.Deleted
            : locale.Restored
        );
      })
      .catch((e) => store().snackbars.error(`Cannot delete form.\n Reason: ${e}`));
  });
};

export const columns: Array<TableSearchColumn<Row>> = [
  {
    label: locale.ContractNumber,
    dataKey: "contractNumber",
    style: { minWidth: 125 },
    cellRenderer: ({ rowData }) => (
      <Body className={"highlighter"}>
        {rowData.contractName} {rowData.contractNumber}
      </Body>
    ),
    width: 300
  },
  {
    label: locale.Customer,
    dataKey: "customer",
    width: 400,
    cellRenderer: ({ rowData }) => (
      <div>
        {rowData.orgCustomerRefs.length > 0 && (
          <Body className="highlighter">
            {" "}
            {rowData.orgCustomerRefs.map((x) => x.Name).join(", \n")}{" "}
          </Body>
        )}
      </div>
    )
  },
  {
    label: locale.Professions,
    dataKey: "professions",
    cellRenderer: ({ rowData }) => <div>{rowData.professions.join(", ")}</div>,
    width: 200
  },
  {
    width: 120,
    label: locale.StartDate,
    dataKey: "contractStart",
    cellRenderer: ({ rowData }) => {
      return <Body>{toLocale.date(rowData.contractStart)}</Body>;
    }
  },
  {
    width: 120,
    label: locale.EndDate,
    dataKey: "contractEnd",
    cellRenderer: ({ rowData }) => {
      return <Body>{toLocale.date(rowData.contractEnd)}</Body>;
    }
  },
  {
    width: 120,
    label: locale.customerContractEdit.currentEndDate,
    dataKey: "currentContractEnd",
    cellRenderer: ({ rowData }) => {
      return <Body>{toLocale.date(rowData.currentContractEnd)}</Body>;
    }
  },
  {
    width: 140,
    label: locale.customerContractEdit.prolongationDate,
    dataKey: "contractProlongation",
    cellRenderer: ({ rowData }) => {
      return <Body>{toLocale.date(rowData.contractProlongation)}</Body>;
    }
  },
  {
    width: 140,
    label: locale.customerContractEdit.priceAdjustmentDate,
    dataKey: "contractPriceAdjustmentDate",
    cellRenderer: ({ rowData }) => {
      return <Body>{toLocale.date(rowData.contractPriceAdjustmentDate)}</Body>;
    }
  },
  {
    width: 160,
    label: locale.customerContractEdit.estimatedContractValue,
    dataKey: "estimatedContractValue",
    cellRenderer: ({ rowData }) => {
      return (
        <Body>
          {rowData.estimatedContractValue != null
            ? toLocale.sek(rowData.estimatedContractValue)
            : ""}
        </Body>
      );
    }
  },
  {
    width: 140,
    label: locale.Status,
    dataKey: "status",
    cellRenderer: ({ rowData }) => {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <Body>{locale.customerContractStatus[rowData.status]}</Body>
          <IconButton
            size={"small"}
            aria-label="delete"
            disabled={false}
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteContract(
                rowData._id,
                rowData.status === CustomerContractStatus.Deleted
              );
            }}
          >
            {rowData.status !== CustomerContractStatus.Deleted ? (
              <Delete fontSize="small" />
            ) : (
              <Restore fontSize="small" />
            )}
          </IconButton>
        </div>
      );
    }
  }
];
